export const AccessRoles = {
  Alarm: {
    Read: "Alarm.Read",
    Update: "Alarm.Update",
  },
  AlarmClass: {
    Read: "AlarmClass.Read",
    Write: "AlarmClass.Write",
    Delete: "AlarmClass.Delete",
  },
  Dashboard: {
    Read: "Dashboard.Read",
    Write: "Dashboard.Write",
    Delete: "Dashboard.Delete",
  },
  Mapping: {
    Read: "Mapping.Read",
    Write: "Mapping.Write",
    Delete: "Mapping.Delete",
  },
  Object: {
    Read: "Object.Read",
    Write: "Object.Write",
    Delete: "Object.Delete",
  },
  History: {
    Read: "History.Read",
  },
  ResourceGroup: {
    Read: "ResourceGroup.Read",
    Write: "ResourceGroup.Write",
  },
  Tenant: {
    Read: "Tenant.Read",
    Write: "Tenant.Write",
  },
  Subscription: {
    Read: "Subscription.Read",
    Write: "Subscription.Write",
  },
  Anomalie: {
    Read: "Anomalie.Read",
    All: "Anomalie.All",
  },
  SuperAdmin: "SuperAdmin",
};
